module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6ea9a9d8b467f46cb1744f87b263a355.png";